// @ts-nocheck
// Settings > 수집 route.
// Approved live behavior in this file: 수신기 실시간 피드 reads raw agent receipt_inbox evidence.
// 영수증 통합분리는 receipt_work_states 후보와 explicit user action API를 사용한다.
import React from 'react';
import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import {
  collectControllerCounts,
  collectControllerGet,
  collectControllerList,
} from '@dvvb/sdk';

import { API_BASE, getStoredToken } from '../../lib/api-client';
import { unwrap } from '../../lib/envelope';
import './collect-design.css';

// dvvb Icons — inline SVG, Lucide-style line icons matching the screenshots.
// Stroke 1.75, rounded join, 18×18 default.

const _ic = (path, opts = {}) => ({ strokeWidth = 1.75, size = 18 } = {}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth={strokeWidth}
    strokeLinecap="round" strokeLinejoin="round"
    style={opts.style}
    aria-hidden="true">
    {path}
  </svg>
);

const Icon = {
  // Top nav
  Operations: _ic(<><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 9h18"/></>),
  Inventory:  _ic(<><path d="M21 8 12 3 3 8l9 5 9-5Z"/><path d="M3 8v8l9 5 9-5V8"/><path d="M12 13v8"/></>),
  Schedule:   _ic(<><rect x="3" y="4" width="18" height="17" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></>),
  Settings:   _ic(<><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h0a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51h0a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v0a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z"/></>),

  // Sidebar
  Store:      _ic(<><path d="M3 9 4 4h16l1 5"/><path d="M3 9v11h18V9"/><path d="M9 21v-6h6v6"/></>),
  Recipe:     _ic(<><path d="M21 8 12 3 3 8l9 5 9-5Z"/><path d="M3 8v8l9 5 9-5V8"/></>),
  Receipt:    _ic(<><path d="M4 2h16v20l-3-2-3 2-2-2-2 2-3-2-3 2z"/><path d="M8 7h8M8 11h8M8 15h5"/></>),
  Truck:      _ic(<><path d="M14 18V6h-5l-2 4H1v4h13z" transform="translate(2 0)"/><circle cx="6" cy="18" r="2"/><circle cx="17" cy="18" r="2"/><path d="M15 18h-4M16 8h4l3 5v5h-3"/></>),
  User:       _ic(<><circle cx="12" cy="8" r="4"/><path d="M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1"/></>),
  Activity:   _ic(<><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></>),
  Box:        _ic(<><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="m3.3 7 8.7 5 8.7-5M12 22V12"/></>),
  Download:   _ic(<><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></>),
  Plus:       _ic(<><path d="M12 5v14M5 12h14"/></>),
  Edit:       _ic(<><path d="M17 3a2.85 2.85 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5z"/></>),
  Trash:      _ic(<><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></>),
  Search:     _ic(<><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></>),
  Copy:       _ic(<><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></>),
  Refresh:    _ic(<><path d="M3 12a9 9 0 0 1 15-6.7L21 8M21 3v5h-5M21 12a9 9 0 0 1-15 6.7L3 16M3 21v-5h5"/></>),
  AlertCircle:_ic(<><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></>),
  Info:       _ic(<><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></>),
  Calendar:   _ic(<><rect x="3" y="4" width="18" height="17" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></>),
  Send:       _ic(<><path d="M22 2 11 13"/><path d="m22 2-7 20-4-9-9-4 20-7Z"/></>),
  Check:      _ic(<><path d="M20 6 9 17l-5-5"/></>),
  ChevronDown:_ic(<><path d="m6 9 6 6 6-6"/></>),
  X:          _ic(<><path d="M18 6 6 18M6 6l12 12"/></>),
  Sparkle:    _ic(<><path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1"/></>),
  Sun:        _ic(<><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/></>),
  Moon:       _ic(<><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></>),
  Pencil:     _ic(<><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></>),
};


// dvvb shared layout — TopNav, PageHeader, Sidebar, common atoms.

function TopNav({ active = "settings", onChange }) {
  const tabs = [
    { id: "operations", label: "운영", icon: Icon.Operations },
    { id: "inventory", label: "재고", icon: Icon.Inventory },
    { id: "schedule", label: "작업일정", icon: Icon.Schedule },
    { id: "settings", label: "설정", icon: Icon.Settings },
  ];
  return (
    <div className="dv-topnav">
      <div className="dv-logo">
        <span className="dv-logo-mark" aria-hidden="true"></span>
        <span>dvvb</span>
      </div>
      <div className="dv-nav-tabs">
        {tabs.map(t => {
          const Ico = t.icon;
          return (
            <button
              key={t.id}
              className={"dv-nav-tab" + (active === t.id ? " is-active" : "")}
              onClick={() => onChange && onChange(t.id)}>
              <Ico size={16} />
              <span>{t.label}</span>
            </button>
          );
        })}
      </div>
      <div className="dv-nav-spacer"></div>
      <div className="dv-avatar">테</div>
    </div>
  );
}

function PageHeader({ title, crumbs, subtitle, right }) {
  return (
    <div style={{ marginBottom: 28 }}>
      <div className="dv-page-title">
        <div style={{ flex: 1 }}>
          <span className="t-display">{title}</span>
          {crumbs && (
            <span className="crumbs" style={{ marginLeft: 12 }}>
              {crumbs.map((c, i) => (
                <React.Fragment key={i}>
                  <span style={{ color: "var(--fg-4)", margin: "0 8px" }}>·</span>
                  <span>{c}</span>
                </React.Fragment>
              ))}
            </span>
          )}
          {subtitle && <div className="dv-page-subtitle" style={{ marginTop: 8, marginBottom: 0 }}>{subtitle}</div>}
        </div>
        {right && <div>{right}</div>}
      </div>
    </div>
  );
}

function SettingsSidebar({ active = "stores", onChange }) {
  const items = [
    { id: "stores", icon: Icon.Store, label: "매장분류", sub: "플랫폼 · 상점 · 메뉴" },
    { id: "recipe", icon: Icon.Recipe, label: "레시피", sub: "메뉴 → 재료 → 자동차감" },
    { id: "collect", icon: Icon.Receipt, label: "수집", sub: "수신기 영수증 · 분류" },
    { id: "windows", icon: Icon.Box, label: "윈도우프로그램", sub: "수신기 다운로드 · 설치 가이드" },
    { id: "vendor", icon: Icon.Truck, label: "거래처", sub: "발주 연결" },
    { id: "staff", icon: Icon.User, label: "직원", sub: "일정 · 알림 연동" },
    { id: "integration", icon: Icon.Activity, label: "연동", sub: "BoxHero · 외부 시스템" },
  ];
  return (
    <div className="dv-sidebar">
      <div className="dv-sidebar-title">설정</div>
      {items.map(it => {
        const Ico = it.icon;
        return (
          <button
            key={it.id}
            className={"dv-sidebar-item" + (active === it.id ? " is-active" : "")}
            onClick={() => onChange && onChange(it.id)}>
            <span className="dv-sidebar-item-icon"><Ico size={18} /></span>
            <span className="dv-sidebar-item-text">
              <span className="dv-sidebar-item-label">{it.label}</span>
              <span className="dv-sidebar-item-sub">{it.sub}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
}

function StatusDot({ color = "var(--green-500)", style }) {
  return <span className="dv-dot" style={{ background: color, ...style }} />;
}

function Badge({ tone = "neutral", children }) {
  return <span className={`dv-badge dv-badge--${tone}`}>{children}</span>;
}

function Button({ variant = "default", size = "md", icon: Ic, children, onClick, style, disabled }) {
  const cls = ["dv-btn"];
  if (variant === "primary") cls.push("dv-btn--primary");
  else if (variant === "ghost") cls.push("dv-btn--ghost");
  else if (variant === "danger") cls.push("dv-btn--danger");
  else if (variant === "link") cls.push("dv-btn--link");
  if (size === "sm") cls.push("dv-btn--sm");
  if (size === "xs") cls.push("dv-btn--xs");
  return (
    <button
      className={cls.join(" ")}
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      style={{
        ...(style || {}),
        ...(disabled ? { opacity: 0.5, cursor: "not-allowed" } : {}),
      }}
    >
      {Ic && <Ic size={14} />}
      <span>{children}</span>
    </button>
  );
}

function ChannelChip({ name, count, active, color, onClick }) {
  return (
    <button className={"dv-chip" + (active ? " is-active" : "")} onClick={onClick}>
      <StatusDot color={color} />
      <span>{name}</span>
      <span className="dv-chip-count">{count}</span>
    </button>
  );
}

function EmptyState({ icon: Ic = Icon.Calendar, title, sub }) {
  return (
    <div className="dv-empty">
      <span className="dv-empty-icon"><Ic size={20} /></span>
      <div className="dv-empty-title">{title}</div>
      {sub && <div className="dv-empty-sub">{sub}</div>}
    </div>
  );
}


// dvvb Settings — 수집 (Collect) v2
// 영수증 통합분리 + 사업장 ▸ 채널 ▸ 상점 트리 + 수신기 실시간 피드.



function CollectDesignPanel() {
  const [tab, setTab] = React.useState("receipt");
  const [selectedStore, setSelectedStore] = React.useState("");
  const [page, setPage] = React.useState("classify"); // "receipts" | "classify" | "feed"
  const workStatesSummaryQ = useReceiptWorkStates();
  const linkOptionsSummaryQ = useWorkStateLinkOptions();
  const workStateCount = workStatesSummaryQ.data?.count ?? workStatesSummaryQ.data?.items?.length ?? "-";
  const linkedTree = React.useMemo(
    () => buildLinkedTreeFromWorkStates(
      workStatesSummaryQ.data?.items || [],
      normalizeLinkOptions(linkOptionsSummaryQ.data),
    ),
    [workStatesSummaryQ.data, linkOptionsSummaryQ.data],
  );
  const [sourceLinks, setSourceLinks] = React.useState({
    business: { source: "", target: "", status: "unlinked" },
    channel: { source: "", target: "", status: "unlinked" },
    store: { source: "", target: "", status: "unlinked" },
  });

  return (
      <>
      <div style={{ width: "100%" }}>

            {/* Header — title + monitor strip */}
            <div style={{
              display: "flex", alignItems: "flex-end", justifyContent: "space-between",
              gap: 24, marginBottom: 22
            }}>
              <div>
                <div style={{ fontSize: 11, fontWeight: 700, color: "var(--fg-3)", letterSpacing: "0.06em", marginBottom: 6 }}>
                  수집 작업대
                </div>
                <div className="t-display" style={{ fontSize: 32, lineHeight: 1.1 }}>수집</div>
              </div>
              <ReceiptHealthStrip onOpenFeed={() => setPage("feed")} />
            </div>

            {/* Body — Left rail (분류 + 트리), Right content */}
            <div style={{ display: "grid", gridTemplateColumns: "280px 1fr", gap: 14 }}>
              <aside style={{
                background: "var(--white)",
                border: "1px solid var(--border-subtle)",
                borderRadius: "var(--r-xl)",
                padding: 14,
                alignSelf: "start",
                position: "sticky",
                top: 80,
                maxHeight: "calc(100vh - 100px)",
                overflowY: "auto"
              }}>
                {/* 수신기 실시간 피드 */}
                <button onClick={() => setPage("feed")} style={{
                  display: "flex", alignItems: "center", gap: 8,
                  width: "100%", textAlign: "left", cursor: "pointer",
                  padding: "9px 10px", borderRadius: "var(--r-sm)",
                  background: page === "feed" ? "var(--orange-50)" : "transparent",
                  border: 0, marginBottom: 4,
                }}>
                  <span style={{
                    width: 16, height: 16, borderRadius: 4,
                    background: "var(--green-100)", color: "var(--green-700)",
                    fontSize: 9, fontWeight: 800,
                    display: "inline-flex", alignItems: "center", justifyContent: "center",
                  }}>◉</span>
                  <span style={{
                    flex: 1, fontSize: 13, fontWeight: page === "feed" ? 700 : 600,
                    color: page === "feed" ? "var(--orange-700)" : "var(--fg-1)",
                  }}>수신기 실시간 피드</span>
                  <span style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: 10, color: "var(--green-600)", fontWeight: 700 }}>
                    <span style={{ width: 6, height: 6, borderRadius: "50%", background: "var(--green-500)" }}></span>LIVE
                  </span>
                </button>

                {/* 영수증 통합분리 (단일 메뉴) */}
                <button onClick={() => setPage("classify")} style={{
                  display: "flex", alignItems: "center", gap: 8,
                  width: "100%", textAlign: "left", cursor: "pointer",
                  padding: "9px 10px", borderRadius: "var(--r-sm)",
                  background: page === "classify" ? "var(--orange-50)" : "transparent",
                  border: 0, marginBottom: 4,
                }}>
                  <span style={{
                    width: 16, height: 16, borderRadius: 4,
                    background: "var(--orange-100)", color: "var(--orange-700)",
                    fontSize: 9, fontWeight: 800,
                    display: "inline-flex", alignItems: "center", justifyContent: "center",
                  }}>★</span>
                  <span style={{
                    flex: 1, fontSize: 13, fontWeight: page === "classify" ? 700 : 600,
                    color: page === "classify" ? "var(--orange-700)" : "var(--fg-1)",
                  }}>영수증 통합분리</span>
                  <span style={{ fontSize: 11, color: "var(--fg-4)", fontWeight: 700 }}>{workStateCount}</span>
                </button>

                <div style={{ height: 1, background: "var(--border-subtle)", margin: "12px 4px" }}></div>

                {/* 연결 트리 (사업장 ▸ 채널 ▸ 상점) */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 10, padding: "0 4px" }}>
                  <span className="t-caption">연결 트리</span>
                  <span style={{ fontSize: 10, color: "var(--fg-4)" }}>사업장·채널·상점</span>
                </div>

                <SourceLinkedTree
                  sourceLinks={sourceLinks}
                  linkedTree={linkedTree}
                  selectedStore={selectedStore}
                  setPage={setPage}
                  setSelectedStore={setSelectedStore}
                />
                <CollectTreeAddRow level={1} label="미연결 후보는 영수증 통합분리 > 사업장 설정에서 연결" />
              </aside>

              <div>
                {page === "feed" ? (
                  <ReceiverFeed />
                ) : page === "classify" ? (
                  <MenuClassifyPage sourceLinks={sourceLinks} onSourceLinksChange={setSourceLinks} />
                ) : (
                  <>
                    <CollectStoreHeader
                      storeName={sourceLinks.store?.target || "상점 연결 필요"}
                      platform={sourceLinks.channel?.target || "판매채널 연결 필요"}
                      business={sourceLinks.business?.target || "사업장 연결 필요"}
                    />

                    <div className="dv-utabs" style={{ marginTop: 18 }}>
                      <button className={"dv-utab" + (tab === "receipt" ? " is-active" : "")} onClick={() => setTab("receipt")}>영수증 <span style={{ marginLeft: 6, color: "var(--fg-3)", fontWeight: 500 }}>0</span></button>
                      <button className={"dv-utab" + (tab === "menu" ? " is-active" : "")} onClick={() => setTab("menu")}>메뉴 매핑 <span style={{ marginLeft: 6, color: "var(--amber-500)", fontWeight: 600 }}>0</span></button>
                    </div>

                    <div style={{ marginTop: 16 }}>
                      {tab === "receipt" && <EmptyState icon={Icon.Receipt} title="연결된 영수증이 없습니다" sub="영수증 통합분리에서 영수증 단위 확인을 먼저 완료해야 합니다." />}
                      {tab === "menu" && <UnifiedMenuMapping />}
                    </div>
                </>
                )}
              </div>
            </div>

      </div>
    </>);

}

function useReceiverFeedRows(paused, selectedDate) {
  return useInfiniteQuery({
    queryKey: ['collect', 'receiver-feed', selectedDate || 'all'],
    initialPageParam: null,
    queryFn: async ({ pageParam }) => {
      const query = { limit: 100 };
      if (selectedDate) query.received_date = selectedDate;
      if (pageParam) query.cursor = pageParam;
      const result = await collectControllerList({ query });
      return unwrap(result);
    },
    getNextPageParam: (lastPage) => lastPage?.has_more && lastPage?.cursor ? lastPage.cursor : undefined,
    refetchInterval: paused ? false : 5_000,
    refetchOnWindowFocus: true,
  });
}

function useCollectInboxCounts(selectedDate) {
  return useQuery({
    queryKey: ['collect', 'inbox-counts', selectedDate || 'all'],
    queryFn: async () => {
      const query = {};
      if (selectedDate) query.received_date = selectedDate;
      const result = await collectControllerCounts({ query });
      return unwrap(result);
    },
    refetchInterval: 10_000,
  });
}

async function collectRawApi(path, init) {
  const token = getStoredToken();
  const response = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: {
      ...(init?.body ? { 'Content-Type': 'application/json' } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(init?.headers || {}),
    },
  });
  const json = await response.json().catch(() => null);
  if (!response.ok || json?.error) {
    throw new Error(json?.error?.message || `API 오류 (HTTP ${response.status})`);
  }
  return json?.data ?? json;
}

function useReceiptWorkStates() {
  return useQuery({
    queryKey: ['collect', 'work-states', 'design-ui'],
    queryFn: () => collectRawApi('/v1/collect/work-states?limit=80'),
    refetchOnMount: 'always',
    staleTime: 10_000,
  });
}

function useWorkStateLinkOptions() {
  return useQuery({
    queryKey: ['collect', 'work-states', 'link-options'],
    queryFn: () => collectRawApi('/v1/collect/work-states/link-options'),
    refetchOnMount: 'always',
    staleTime: 30_000,
  });
}

function useWorkStateAction(onSuccess) {
  return useMutation({
    mutationFn: ({ receiptId, body }) =>
      collectRawApi(`/v1/collect/work-states/${receiptId}/actions`, {
        method: 'POST',
        body: JSON.stringify(body),
      }),
    onSuccess,
  });
}

function normalizeWorkStateReceipts(items) {
  if (!Array.isArray(items)) return [];
  return items.map((item) => {
    const sourcePieces = Array.isArray(item?.keywordState?.pieces)
      ? item.keywordState.pieces.filter((piece) => piece?.kind === 'source')
      : [];
    const noisePieces = Array.isArray(item?.keywordState?.noiseCandidates)
      ? item.keywordState.noiseCandidates
      : [];
    const previewLines = Array.isArray(item?.keywordState?.splitInputPreview?.lines)
      ? item.keywordState.splitInputPreview.lines
      : [];
    const menuLines = previewLines
      .filter((line) => !noisePieces.some((noise) => noise?.text && line?.text?.includes(noise.text)))
      .slice(0, 12)
      .map((line) => ({
        id: line.id || `${item.receiptInboxId}-${line.loc}`,
        kind: 'menu',
        loc: line.loc || '-',
        text: line.text || '-',
        type: '메뉴',
        state: line.state || '검수 필요',
        reason: '노이즈 전처리 후 통합분리 입력',
        next: '메뉴 매핑',
      }));
    const lines = [
      { id: `${item.receiptInboxId}-section-source`, kind: 'section', text: '원본/source 후보' },
      ...sourcePieces.map((piece) => normalizeWorkPiece(item, piece)),
      { id: `${item.receiptInboxId}-section-menu`, kind: 'section', text: '통합분리 입력' },
      ...menuLines,
      { id: `${item.receiptInboxId}-section-noise`, kind: 'section', text: '노이즈 후보' },
      ...noisePieces.map((piece) => normalizeWorkPiece(item, piece, 'noise')),
    ].filter(Boolean);
    const status = reviewText(item.reviewStatus);
    return {
      id: item.receiptInboxId,
      title: item.receiptInboxId,
      time: formatCollectTime(item.receipt?.receivedAt || item.updatedAt),
      business: item.sourceBusinessLabel || '사업장 후보 없음',
      channel: item.sourceSalesChannelLabel || '판매채널 후보 없음',
      store: item.sourceStoreLabel || '상점 후보 없음',
      status,
      tone: reviewTone(item.reviewStatus),
      queue: buildWorkStateQueue(item, menuLines, noisePieces),
      counts: {
        noise: noisePieces.length,
        menu: menuLines.length,
        hold: item.reviewStatus === 'held' ? 1 : 0,
      },
      lines,
      raw: item,
    };
  });
}

function normalizeWorkPiece(item, piece, forcedKind) {
  if (!piece) return null;
  return {
    id: piece.id || `${item.receiptInboxId}-${piece.loc}-${piece.text}`,
    kind: forcedKind || piece.kind || (piece.type === '노이즈' ? 'noise' : 'source'),
    loc: piece.loc || '-',
    text: piece.text || '-',
    type: piece.type || (forcedKind === 'noise' ? '노이즈' : '보류'),
    state: piece.state || '검수 필요',
    reason: piece.reason || '수집워커 후보',
    next: piece.effect || piece.next || nextForPieceType(piece.type),
  };
}

function buildWorkStateQueue(item, menuLines, noisePieces) {
  const queue = ['all'];
  if (item.reviewStatus === 'completed') queue.push('done');
  else queue.push('needs_review');
  if (menuLines.length > 0) queue.push('menu_review');
  if (noisePieces.length > 0) queue.push('noise');
  if (item.reviewStatus === 'held') queue.push('hold');
  return queue;
}

function reviewText(status) {
  if (status === 'completed') return '완료';
  if (status === 'held') return '보류';
  if (status === 'ignored') return '무시';
  return '검수 필요';
}

function reviewTone(status) {
  if (status === 'completed') return 'success';
  if (status === 'held') return 'warn';
  if (status === 'ignored') return 'neutral';
  return 'warn';
}

function nextForPieceType(type) {
  if (type === '사업장') return '연결 트리 > 사업장 연결';
  if (type === '판매채널') return '연결 트리 > 판매채널 연결';
  if (type === '상점') return '연결 트리 > 상점 연결';
  if (type === '메뉴') return '메뉴 매핑';
  if (type === '노이즈') return '노이즈 제외';
  return '보류';
}

function formatCollectTime(value) {
  if (!value) return '-';
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return value;
  return `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
}

function findReceiptLine(receipts, lineId) {
  for (const receipt of receipts) {
    const line = receipt.lines?.find((candidate) => candidate.id === lineId);
    if (line) return { receipt, line };
  }
  return { receipt: null, line: null };
}

function listItems(response) {
  return Array.isArray(response?.items) ? response.items : [];
}

function normalizeLinkOptions(response) {
  return {
    locations: Array.isArray(response?.locations) ? response.locations : [],
    platforms: Array.isArray(response?.platforms) ? response.platforms : [],
    stores: Array.isArray(response?.stores) ? response.stores : [],
  };
}

function optionName(items, id, fallback = "") {
  if (!id) return fallback;
  return items.find((item) => item.id === id)?.name || fallback || id;
}

function sourceLabel(value, fallback) {
  if (value === null || value === undefined || value === "" || value === "unknown") return fallback;
  return String(value);
}

function buildSourceLinks(receipt, linkOptions, ids, status = "linked") {
  return {
    business: {
      source: sourceLabel(receipt?.business, "사업장 후보 없음"),
      target: optionName(linkOptions.locations, ids.locationId, ""),
      status: ids.locationId ? status : "unlinked",
    },
    channel: {
      source: sourceLabel(receipt?.channel, "판매채널 후보 없음"),
      target: optionName(linkOptions.platforms, ids.platformId, ""),
      status: ids.platformId ? status : "unlinked",
    },
    store: {
      source: sourceLabel(receipt?.store, "상점 후보 없음"),
      target: optionName(linkOptions.stores, ids.storeId, ""),
      status: ids.storeId ? status : "unlinked",
    },
  };
}

function buildLinkedTreeFromWorkStates(items, linkOptions) {
  const locationsById = new Map(linkOptions.locations.map((item) => [item.id, item]));
  const platformsById = new Map(linkOptions.platforms.map((item) => [item.id, item]));
  const storesById = new Map(linkOptions.stores.map((item) => [item.id, item]));
  const linkedItems = Array.isArray(items) ? items : [];
  const receiptCountByLocation = new Map();
  const receiptCountByPlatform = new Map();
  const receiptCountByStore = new Map();
  const locationBuckets = new Map();

  linkedItems.forEach((item) => {
    if (item?.linkedLocationId) {
      receiptCountByLocation.set(item.linkedLocationId, (receiptCountByLocation.get(item.linkedLocationId) || 0) + 1);
    }
    if (item?.linkedLocationId && item?.linkedPlatformId) {
      const key = `${item.linkedLocationId}:${item.linkedPlatformId}`;
      receiptCountByPlatform.set(key, (receiptCountByPlatform.get(key) || 0) + 1);
    }
    if (item?.linkedStoreId) {
      receiptCountByStore.set(item.linkedStoreId, (receiptCountByStore.get(item.linkedStoreId) || 0) + 1);
    }
  });

  const ensureLocation = (locationId, fallbackName) => {
    if (!locationBuckets.has(locationId)) {
      locationBuckets.set(locationId, {
        id: locationId,
        name: locationsById.get(locationId)?.name || fallbackName || locationId,
        count: receiptCountByLocation.get(locationId) || 0,
        platforms: new Map(),
      });
    }
    return locationBuckets.get(locationId);
  };

  const ensurePlatform = (location, platformId, fallbackName) => {
    const platformKey = platformId || `missing-platform:${location.id}`;
    if (!location.platforms.has(platformKey)) {
      const receiptCountKey = `${location.id}:${platformId}`;
      location.platforms.set(platformKey, {
        id: platformKey,
        platformId,
        name: platformId
          ? platformsById.get(platformId)?.name || fallbackName || platformId
          : "판매채널 연결 필요",
        count: receiptCountByPlatform.get(receiptCountKey) || 0,
        stores: new Map(),
      });
    }
    return location.platforms.get(platformKey);
  };

  linkOptions.stores.forEach((store) => {
    if (!store.locationId) return;
    const location = ensureLocation(store.locationId);
    const platform = ensurePlatform(location, store.platformId || "");
    const count = receiptCountByStore.get(store.id) || 0;
    platform.stores.set(store.id, {
      id: store.id,
      storeId: store.id,
      name: store.name,
      count,
      status: count > 0 ? "ok" : "empty",
    });
  });

  linkedItems.forEach((item) => {
    const locationId = item?.linkedLocationId;
    if (!locationId) return;
    const platformId = item?.linkedPlatformId || "";
    const storeId = item?.linkedStoreId || "";
    const storeRecord = storeId ? storesById.get(storeId) : null;
    const storeName = storeId
      ? storeRecord?.name || item.sourceStoreLabel || storeId
      : "상점 연결 필요";
    const location = ensureLocation(locationId, item.sourceBusinessLabel);
    const platform = ensurePlatform(location, platformId, item.sourceSalesChannelLabel);
    const storeKey = storeId || `missing-store:${item.receiptInboxId || item.id}`;
    if (!platform.stores.has(storeKey)) {
      platform.stores.set(storeKey, {
        id: storeKey,
        storeId,
        name: storeName,
        count: 0,
        status: storeId ? "ok" : "warn",
      });
    }
    if (!storeId || !storesById.has(storeId)) {
      platform.stores.get(storeKey).count += 1;
    }
  });

  return Array.from(locationBuckets.values())
    .map((location) => ({
      ...location,
      platforms: Array.from(location.platforms.values()).map((platform) => ({
        ...platform,
        stores: Array.from(platform.stores.values()).sort((a, b) => a.name.localeCompare(b.name, "ko")),
      })).sort((a, b) => a.name.localeCompare(b.name, "ko")),
    }))
    .sort((a, b) => a.name.localeCompare(b.name, "ko"));
}

function buildCompletedRows(receipts, linkOptions) {
  const rows = [];
  receipts.forEach((receipt) => {
    const raw = receipt?.raw || {};
    if (raw.linkedLocationId) {
      rows.push({
        id: `${receipt.id}-linked-location`,
        value: optionName(linkOptions.locations, raw.linkedLocationId, raw.linkedLocationId),
        type: "사업장",
        scope: sourceLabel(receipt.business, "사업장 후보 없음"),
        next: raw.linkedStoreId ? "연결 완료" : "연결 대기",
      });
    }
    if (raw.linkedPlatformId) {
      rows.push({
        id: `${receipt.id}-linked-platform`,
        value: optionName(linkOptions.platforms, raw.linkedPlatformId, raw.linkedPlatformId),
        type: "판매채널",
        scope: sourceLabel(receipt.channel, "판매채널 후보 없음"),
        next: raw.linkedStoreId ? "연결 완료" : "연결 대기",
      });
    }
    if (raw.linkedStoreId) {
      rows.push({
        id: `${receipt.id}-linked-store`,
        value: optionName(linkOptions.stores, raw.linkedStoreId, raw.linkedStoreId),
        type: "상점",
        scope: sourceLabel(receipt.store, "상점 후보 없음"),
        next: raw.reviewStatus === "completed" ? "분리 완료" : "영수증 완료 대기",
      });
    }
    receipt.lines
      .filter((line) => line.kind === "noise" && line.state === "확정")
      .forEach((line) => {
        rows.push({
          id: `${receipt.id}-${line.id}-noise`,
          value: line.text,
          type: "노이즈",
          scope: `${receipt.id} · ${line.loc}`,
          next: "분리 완료",
        });
      });
  });
  return rows;
}

function buildSplitRuleRows(receipts) {
  return receipts.flatMap((receipt) =>
    receipt.lines
      .filter((line) => line.kind === "noise" && line.state === "확정")
      .map((line) => ({
        id: `${receipt.id}-${line.id}-rule`,
        value: line.text,
        type: "노이즈",
        auto: true,
        lastEvidence: `${receipt.id} · ${line.loc}`,
      })),
  );
}

function jsonArray(value) {
  return Array.isArray(value) ? value : [];
}

function formatDateTime(value) {
  if (!value) return '-';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}:${String(d.getSeconds()).padStart(2, '0')}`;
}

function formatDateInput(value = new Date()) {
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

function relativeTime(value) {
  if (!value) return '-';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '-';
  const diff = Math.max(0, Date.now() - d.getTime());
  const seconds = Math.floor(diff / 1000);
  if (seconds < 60) return `${seconds}초 전`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}분 전`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}시간 전`;
  return `${Math.floor(hours / 24)}일 전`;
}

function rawField(value) {
  if (value === null || value === undefined || value === '') return '-';
  return String(value);
}

function receiveState(row) {
  if (row?.parseStatus === 'failed') return 'parse_failed';
  if (row?.isCancellation) return 'cancelled';
  return 'received';
}

function receiveStateLabel(state) {
  if (state === 'parse_failed') return '파싱 실패';
  if (state === 'cancelled') return '취소 표시';
  return '원본 수신';
}

function normalizeFeedRow(row) {
  const state = receiveState(row);
  const raw = row?.decodedTextPreview || '(원문 없음)';
  return {
    id: row?.id,
    time: formatDateTime(row?.receivedAt),
    statusLabel: receiveStateLabel(state),
    state,
    raw,
    row,
    receivedAt: row?.receivedAt,
    receiverName: row?.receiver?.deviceName || '수신기 미확인',
    eventId: rawField(row?.eventId),
    externalSiteId: rawField(row?.externalSiteId),
    platformId: rawField(row?.platformId),
    platformStoreId: rawField(row?.platformStoreId),
    parseStatus: rawField(row?.parseStatus),
    classificationStatus: rawField(row?.classificationStatus),
    rawChecksum: rawField(row?.rawChecksum),
    isCancellation: Boolean(row?.isCancellation),
  };
}

function excelCell(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function exportFeedExcel(items, selectedDate, filter) {
  const headers = [
    '수신시각',
    '수신상태',
    '수신기',
    'receipt_inbox_id',
    'event_id',
    'external_site_id',
    'platform_id',
    'platform_store_id',
    'parse_status',
    'classification_status(raw)',
    'is_cancellation',
    'raw_checksum',
    '원문 미리보기',
  ];
  const rows = items.map((item) => [
    item.time,
    item.statusLabel,
    item.receiverName,
    item.id,
    item.eventId,
    item.externalSiteId,
    item.platformId,
    item.platformStoreId,
    item.parseStatus,
    item.classificationStatus,
    item.isCancellation ? 'true' : 'false',
    item.rawChecksum,
    item.raw,
  ]);
  const table = [headers, ...rows]
    .map((row) => `<tr>${row.map((cell) => `<td>${excelCell(cell)}</td>`).join('')}</tr>`)
    .join('');
  const html = `<!doctype html><html><head><meta charset="utf-8"></head><body><table border="1">${table}</table></body></html>`;
  const blob = new Blob(['\ufeff', html], {
    type: 'application/vnd.ms-excel;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `receiver-feed-${selectedDate || 'all'}-${filter}.xls`;
  a.click();
  URL.revokeObjectURL(url);
}

// ─── 수신기 실시간 피드 (원본 수신 확인) ──────────────────
function ReceiverFeed() {
  const [paused, setPaused] = React.useState(false);
  const [openRaw, setOpenRaw] = React.useState(null);
  const [filter, setFilter] = React.useState('all');
  const [selectedDate, setSelectedDate] = React.useState(() => formatDateInput());
  const loadMoreRef = React.useRef(null);
  const feedQ = useReceiverFeedRows(paused, selectedDate);
  const countsQ = useCollectInboxCounts(selectedDate);

  const pages = Array.isArray(feedQ.data?.pages) ? feedQ.data.pages : [];
  const items = pages.flatMap(listItems).map(normalizeFeedRow);
  const latest = items[0] || null;
  const filters = [
    { id: 'all', label: '전체', color: 'var(--fg-3)' },
    { id: 'received', label: '원본 수신', color: 'var(--green-500)' },
    { id: 'parse_failed', label: '파싱 실패', color: 'var(--amber-500)' },
    { id: 'cancelled', label: '취소 표시', color: 'var(--red-500)' },
  ];
  const filtered = filter === 'all' ? items : items.filter((i) => i.state === filter);
  const counts = countsQ.data || {};

  const refresh = () => {
    void feedQ.refetch();
    void countsQ.refetch();
  };

  React.useEffect(() => {
    const target = loadMoreRef.current;
    if (!target) return undefined;

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (!entry?.isIntersecting) return;
      if (paused || !feedQ.hasNextPage || feedQ.isFetchingNextPage) return;
      void feedQ.fetchNextPage();
    }, { rootMargin: '240px 0px' });

    observer.observe(target);
    return () => observer.disconnect();
  }, [feedQ.hasNextPage, feedQ.isFetchingNextPage, feedQ.fetchNextPage, paused, selectedDate]);

  return (
    <>
      <div style={{
        background: 'var(--white)', border: '1px solid var(--border-subtle)',
        borderRadius: 'var(--r-xl)', padding: '14px 18px', marginBottom: 14,
        display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{
            width: 10, height: 10, borderRadius: '50%',
            background: paused ? 'var(--gray-400)' : feedQ.isError ? 'var(--red-500)' : 'var(--green-500)',
            animation: paused || feedQ.isError ? 'none' : 'v2pulse 1.6s ease-out infinite',
          }}></span>
          <span style={{ fontSize: 13, fontWeight: 700, color: paused ? 'var(--fg-3)' : feedQ.isError ? 'var(--red-600)' : 'var(--green-700)' }}>
            {paused ? '일시정지' : feedQ.isError ? 'LIVE · 조회 오류' : 'LIVE · agent 수신 조회'}
          </span>
        </div>
        <span style={{ fontSize: 12, color: 'var(--fg-3)' }}>마지막 수신 <b>{latest ? relativeTime(latest.receivedAt) : '-'}</b></span>
        <span style={{ fontSize: 12, color: 'var(--fg-3)' }}>
          {selectedDate || '전체 최신'} 표시 <b>{items.length}</b>건 · 원본 수신 <b>{counts.total ?? '-'}</b>건
        </span>
        <div style={{ flex: 1 }}></div>
        <label style={{
          display: 'inline-flex', alignItems: 'center', gap: 6,
          border: '1px solid var(--border-subtle)', borderRadius: 'var(--r-sm)',
          padding: '6px 9px', background: 'var(--white)', color: 'var(--fg-2)',
          fontSize: 12, fontWeight: 700,
        }}>
          <Icon.Calendar size={14} />
          <input
            type="date"
            value={selectedDate}
            onChange={(event) => setSelectedDate(event.target.value)}
            style={{
              border: 0, outline: 0, background: 'transparent',
              color: 'var(--fg-1)', font: 'inherit', width: 128,
            }}
          />
        </label>
        <Button variant="ghost" size="sm" icon={Icon.Calendar} onClick={() => setSelectedDate(formatDateInput())}>오늘</Button>
        <Button variant="ghost" size="sm" icon={Icon.Search} onClick={() => setSelectedDate('')}>전체</Button>
        <Button variant="ghost" size="sm" icon={paused ? Icon.Activity : Icon.AlertCircle} onClick={() => setPaused((p) => !p)}>
          {paused ? '재개' : '일시정지'}
        </Button>
        <Button variant="ghost" size="sm" icon={Icon.Refresh} onClick={refresh}>새로고침</Button>
        <Button variant="ghost" size="sm" icon={Icon.Download} onClick={() => exportFeedExcel(filtered, selectedDate, filter)}>엑셀</Button>
      </div>

      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 12 }}>
        {filters.map((f) => {
          const c = f.id === 'all'
            ? counts.total ?? items.length
            : items.filter((i) => i.state === f.id).length;
          return (
            <button key={f.id} onClick={() => setFilter(f.id)} className={'dv-chip' + (filter === f.id ? ' is-active' : '')}>
              <span className="dv-dot" style={{ background: f.color }}></span>
              {f.label}
              <span className="dv-chip-count">{c}</span>
            </button>
          );
        })}
      </div>

      {feedQ.isLoading && (
        <EmptyState icon={Icon.Activity} title="수신 피드 조회 중" sub="agent 수신 대기함을 읽고 있습니다." />
      )}
      {feedQ.isError && (
        <EmptyState icon={Icon.AlertCircle} title="수신 피드 조회 실패" sub="수집 API 또는 agent DB 연결 상태를 확인해야 합니다." />
      )}
      {!feedQ.isLoading && !feedQ.isError && filtered.length === 0 && (
        <EmptyState icon={Icon.Receipt} title="표시할 수신 내역이 없습니다" sub="필터를 바꾸거나 새로고침해 확인하세요." />
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {filtered.map((it) => (
          <div key={it.id} onClick={() => setOpenRaw(it)} style={{
            background: 'var(--white)', border: '1px solid var(--border-subtle)',
            borderLeft: it.state === 'parse_failed' ? '3px solid var(--amber-500)' : it.state === 'cancelled' ? '3px solid var(--red-500)' : '3px solid var(--green-500)',
            borderRadius: 'var(--r-lg)', padding: '14px 16px 14px 13px',
            display: 'grid', gridTemplateColumns: 'auto 1fr auto', gap: 16, alignItems: 'center',
            cursor: 'pointer',
          }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4, minWidth: 170 }}>
              <div style={{ fontSize: 11, fontFamily: 'var(--font-mono)', color: 'var(--fg-3)' }}>{it.time}</div>
              <div style={{ fontSize: 10, fontFamily: 'var(--font-mono)', color: 'var(--fg-4)' }}>{it.id}</div>
            </div>
            <div style={{ minWidth: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 3, flexWrap: 'wrap' }}>
                <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--fg-2)' }}>수신기: {it.receiverName}</span>
                <span style={{ color: 'var(--fg-4)' }}>·</span>
                <span style={{ fontSize: 11, fontFamily: 'var(--font-mono)', color: 'var(--fg-3)' }}>event_id {it.eventId}</span>
                <span style={{ fontSize: 11, fontFamily: 'var(--font-mono)', color: 'var(--fg-3)' }}>platform_id {it.platformId}</span>
                <span style={{ fontSize: 11, fontFamily: 'var(--font-mono)', color: 'var(--fg-3)' }}>platform_store_id {it.platformStoreId}</span>
              </div>
              <div style={{ fontSize: 11, fontFamily: 'var(--font-mono)', color: 'var(--fg-3)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {it.raw.split('\n').slice(0, 3).join(' · ')}
              </div>
            </div>
            <div>
              {it.state === 'received' && <Badge tone="success">원본 수신</Badge>}
              {it.state === 'parse_failed' && <Badge tone="warn">파싱 실패</Badge>}
              {it.state === 'cancelled' && <Badge tone="danger">취소 표시</Badge>}
            </div>
          </div>
        ))}
      </div>

      {!feedQ.isLoading && !feedQ.isError && (
        <div ref={loadMoreRef} style={{ padding: '14px 0 4px', display: 'flex', justifyContent: 'center' }}>
          {feedQ.isFetchingNextPage ? (
            <span style={{ fontSize: 12, color: 'var(--fg-3)' }}>30개 더 불러오는 중...</span>
          ) : feedQ.hasNextPage ? (
            <Button variant="ghost" size="sm" icon={Icon.Refresh} onClick={() => feedQ.fetchNextPage()}>30개 더 보기</Button>
          ) : items.length > 0 ? (
            <span style={{ fontSize: 12, color: 'var(--fg-4)' }}>선택한 날짜의 원본 수신 내역을 모두 불러왔습니다.</span>
          ) : null}
        </div>
      )}

      {openRaw && <ReceiverDetailDialog item={openRaw} onClose={() => setOpenRaw(null)} />}
    </>
  );
}

// ─── 영수증 상세 팝업 (원문 + 원본 분리) ─────────────────
function ReceiverDetailDialog({ item, onClose }) {
  const detailQ = useQuery({
    queryKey: ['collect', 'receiver-feed-detail', item.id],
    queryFn: async () => {
      const result = await collectControllerGet({ path: { id: item.id } });
      return unwrap(result);
    },
    enabled: Boolean(item?.id),
  });
  const detail = detailQ.data?.item || item.row || {};
  const payload = detail.payload || null;
  const decodedText = detail.decodedText || item.raw || '';
  const tableRows = [
    ['ID', detail.id || item.id],
    ['수신기', detail.receiver?.deviceName || item.receiverName || '-'],
    ['수신 시각', formatDateTime(detail.receivedAt || item.receivedAt)],
    ['캡처 시각', formatDateTime(detail.capturedAt)],
    ['event_id', rawField(detail.eventId)],
    ['external_site_id', rawField(detail.externalSiteId)],
    ['platform_id', rawField(detail.platformId)],
    ['platform_store_id', rawField(detail.platformStoreId)],
    ['matched_store_id', rawField(detail.matchedStoreId)],
    ['matched_platform_id', rawField(detail.matchedPlatformId)],
    ['parse_status', rawField(detail.parseStatus)],
    ['classification_status(raw)', rawField(detail.classificationStatus || item.row?.classificationStatus)],
    ['is_cancellation', detail.isCancellation ? 'true' : 'false'],
    ['port', rawField(detail.port)],
    ['raw_checksum', rawField(detail.rawChecksum)],
    ['raw_receipt_id', detail.rawReceiptId || '-'],
  ];

  const copyDecodedText = async () => {
    try {
      await navigator.clipboard.writeText(decodedText);
    } catch {
      // Clipboard failures are non-blocking for this read-only monitor.
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(21,20,15,.42)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200, padding: 20 }} onClick={onClose}>
      <div style={{ width: 760, maxWidth: '100%', maxHeight: '92vh', background: 'var(--white)', borderRadius: 'var(--r-xl)', boxShadow: 'var(--shadow-lg)', overflowY: 'auto', display: 'flex', flexDirection: 'column' }} onClick={(e) => e.stopPropagation()}>
        <div style={{ padding: '20px 24px 14px', borderBottom: '1px solid var(--border-subtle)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div className="t-h1" style={{ fontSize: 20 }}>영수증 상세</div>
          <button className="dv-btn dv-btn--ghost dv-btn--xs" onClick={onClose}><Icon.X size={14} /></button>
        </div>

        <div style={{ padding: '16px 24px 20px', overflowY: 'auto' }}>
          {detailQ.isLoading && <div className="t-small" style={{ marginBottom: 12 }}>상세 조회 중...</div>}
          {detailQ.isError && <div className="t-small" style={{ marginBottom: 12, color: 'var(--red-600)' }}>상세 조회 실패. 목록에 있는 정보만 표시합니다.</div>}
          <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 18, fontSize: 13 }}>
            <tbody>
              {tableRows.map(([k, v], i) => (
                <tr key={i} style={{ borderBottom: i < tableRows.length - 1 ? '1px solid var(--border-subtle)' : 0 }}>
                  <td style={{ padding: '8px 14px 8px 0', color: 'var(--fg-3)', fontSize: 12, width: 160, verticalAlign: 'top' }}>{k}</td>
                  <td style={{ padding: '8px 0', color: 'var(--fg-1)', fontFamily: typeof v === 'string' && /^[a-z0-9_:.-]+$/i.test(v) ? 'var(--font-mono)' : 'inherit', fontSize: 12, wordBreak: 'break-all' }}>{v}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="t-caption" style={{ marginBottom: 6, color: 'var(--fg-2)', fontWeight: 700 }}>decoded_text (원문)</div>
          <pre style={{
            background: 'var(--cream-50)', border: '1px solid var(--border-subtle)',
            borderRadius: 'var(--r-sm)', padding: 14,
            fontFamily: 'var(--font-mono)', fontSize: 12,
            color: 'var(--fg-1)', margin: '0 0 18px', whiteSpace: 'pre-wrap',
            lineHeight: 1.7, maxHeight: 280, overflowY: 'auto',
          }}>{decodedText || '(원문 없음)'}</pre>

          <div className="t-caption" style={{ marginBottom: 6, color: 'var(--fg-2)', fontWeight: 700 }}>payload (원본)</div>
          <pre style={{
            background: 'var(--cream-50)', border: '1px solid var(--border-subtle)',
            borderRadius: 'var(--r-sm)', padding: 14,
            fontFamily: 'var(--font-mono)', fontSize: 11.5,
            color: 'var(--fg-2)', margin: 0, whiteSpace: 'pre-wrap',
            lineHeight: 1.6, maxHeight: 240, overflowY: 'auto',
          }}>{JSON.stringify(payload || {}, null, 2)}</pre>
        </div>

        <div style={{ padding: '12px 24px', borderTop: '1px solid var(--border-subtle)', display: 'flex', justifyContent: 'space-between', background: 'var(--cream-50)' }}>
          <Button variant="ghost" size="sm" icon={Icon.Copy} onClick={copyDecodedText}>원문 복사</Button>
          <div style={{ display: 'flex', gap: 8 }}>
            <Button variant="primary" size="sm" onClick={onClose}>닫기</Button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── 영수증 통합분리 페이지 (영수증 단위 원본 조각 검수) ──────────────────
function MenuClassifyPage({ sourceLinks, onSourceLinksChange }) {
  const workStatesQ = useReceiptWorkStates();
  const linkOptionsQ = useWorkStateLinkOptions();
  const workStateAction = useWorkStateAction(() => workStatesQ.refetch());
  const workStateReceipts = React.useMemo(
    () => normalizeWorkStateReceipts(workStatesQ.data?.items || []),
    [workStatesQ.data],
  );
  const linkOptions = React.useMemo(
    () => normalizeLinkOptions(linkOptionsQ.data),
    [linkOptionsQ.data],
  );
  const receiptsSource = workStateReceipts;
  const completedRows = React.useMemo(
    () => buildCompletedRows(receiptsSource, linkOptions),
    [receiptsSource, linkOptions],
  );
  const splitRuleRows = React.useMemo(
    () => buildSplitRuleRows(receiptsSource),
    [receiptsSource],
  );
  const [tab, setTab] = React.useState("workbench");
  const [queueFilter, setQueueFilter] = React.useState("needs_review");
  const [selectedReceiptId, setSelectedReceiptId] = React.useState(receiptsSource[0]?.id || "");
  React.useEffect(() => {
    if (!selectedReceiptId && receiptsSource[0]) setSelectedReceiptId(receiptsSource[0].id);
    if (selectedReceiptId && receiptsSource.length && !receiptsSource.some((receipt) => receipt.id === selectedReceiptId)) {
      setSelectedReceiptId(receiptsSource[0].id);
    }
  }, [receiptsSource, selectedReceiptId]);
  const selectedReceipt = receiptsSource.find((receipt) => receipt.id === selectedReceiptId) || receiptsSource[0];
  const sourceRowsCount = selectedReceipt ? 3 : 0;
  const firstSelectableLine = selectedReceipt?.lines.find((line) => line.kind !== "section") || selectedReceipt?.lines[0];
  const [selectedLineId, setSelectedLineId] = React.useState(firstSelectableLine?.id || "");
  React.useEffect(() => {
    const lineExists = selectedReceipt?.lines.some((line) => line.id === selectedLineId);
    if (selectedReceipt && (!selectedLineId || !lineExists)) {
      const firstLine = selectedReceipt.lines.find((line) => line.kind !== "section") || selectedReceipt.lines[0];
      setSelectedLineId(firstLine?.id || "");
    }
  }, [selectedReceipt, selectedLineId]);
  const [lineStates, setLineStates] = React.useState({});
  const selectedLine =
    selectedReceipt?.lines.find((line) => line.id === selectedLineId) ||
    firstSelectableLine ||
    selectedReceipt?.lines[0];
  const filteredReceipts =
    queueFilter === "all"
      ? receiptsSource
      : receiptsSource.filter((receipt) => receipt.queue.includes(queueFilter));
  const queueStats = RECEIPT_QUEUE_FILTERS.map((filter) => ({
    ...filter,
    count: filter.id === "all"
      ? receiptsSource.length
      : receiptsSource.filter((receipt) => receipt.queue.includes(filter.id)).length,
  }));
  const noiseCandidates = receiptsSource.flatMap((receipt) =>
    receipt.lines
      .filter((line) => line.kind === "noise")
      .map((line) => ({ ...line, receipt }))
  );
  const keywordCandidateCount = receiptsSource.reduce((total, receipt) => (
    total + receipt.lines.filter((line) => line.kind !== "section" && line.kind !== "noise").length
  ), 0);

  const selectReceipt = (receipt) => {
    setSelectedReceiptId(receipt.id);
    const firstLine = receipt.lines.find((line) => line.kind !== "section" && line.kind !== "noise") || receipt.lines[0];
    setSelectedLineId(firstLine?.id || "");
  };

  const applyReceiptAction = (receipt, action) => {
    if (!receipt?.raw?.receiptInboxId) return;
    workStateAction.mutate({
      receiptId: receipt.raw.receiptInboxId,
      body: { action },
    });
  };

  const setLineState = (lineId, nextState) => {
    const { receipt, line } = findReceiptLine(receiptsSource, lineId);
    if (receipt?.raw && line) {
      if (line.kind === "noise" || line.type === "노이즈") {
        if (nextState === "확정" || nextState === "노이즈") {
          workStateAction.mutate({
            receiptId: receipt.raw.receiptInboxId,
            body: { action: "confirm_noise", noiseCandidateId: line.id },
          });
        } else if (nextState === "검수 필요" || nextState === "키워드 수집") {
          workStateAction.mutate({
            receiptId: receipt.raw.receiptInboxId,
            body: { action: "reopen_noise", noiseCandidateId: line.id },
          });
        } else if (nextState === "보류") {
          workStateAction.mutate({
            receiptId: receipt.raw.receiptInboxId,
            body: { action: "hold" },
          });
        }
      } else if (nextState === "보류") {
        workStateAction.mutate({
          receiptId: receipt.raw.receiptInboxId,
          body: { action: "hold" },
        });
      }
    }
    setLineStates((current) => ({ ...current, [lineId]: nextState }));
  };

  return (
    <>
      <div className="dv-card" style={{ padding: 18, marginBottom: 12 }}>
        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 16 }}>
          <div>
            <div className="t-h2">영수증 통합분리</div>
            <div className="t-small" style={{ marginTop: 4 }}>
              원본 기본값과 영수증 키워드를 검수하고, 노이즈와 보류 사유를 따로 분리합니다.
            </div>
          </div>
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap", justifyContent: "flex-end" }}>
            <Badge tone="warn">검수 필요 {queueStats.find((s) => s.id === "needs_review")?.count || 0}</Badge>
            <Badge tone="neutral">노이즈 후보 {noiseCandidates.length}</Badge>
            <Badge tone="orange">메뉴 후보 {queueStats.find((s) => s.id === "menu_review")?.count || 0}</Badge>
            <Badge tone="success">분리 완료 {completedRows.length}</Badge>
          </div>
        </div>
      </div>

      <ReceiptAnalysisSummary receipts={receiptsSource} />

      <div className="dv-utabs" style={{ marginBottom: 14 }}>
        {[
          ["workbench", "검수 작업대", keywordCandidateCount],
          ["noise", "노이즈", noiseCandidates.length],
          ["source", "사업장 설정", sourceRowsCount],
          ["done", "분리 완료", completedRows.length],
          ["settings", "분리 설정", splitRuleRows.length],
        ].map(([id, label, count]) => (
          <button key={id} className={"dv-utab" + (tab === id ? " is-active" : "")} onClick={() => setTab(id)}>
            {label} <span style={{ marginLeft: 6, color: "var(--fg-3)", fontWeight: 600 }}>{count}</span>
          </button>
        ))}
      </div>

      {tab === "workbench" && (
        <ReceiptWorkbench
          queueFilter={queueFilter}
          queueStats={queueStats}
          receipts={filteredReceipts}
          selectedReceipt={selectedReceipt}
          selectedLine={selectedLine}
          lineStates={lineStates}
          onQueueFilter={setQueueFilter}
          onSelectReceipt={selectReceipt}
          onSelectLine={setSelectedLineId}
          onLineState={setLineState}
          onReceiptAction={applyReceiptAction}
          busy={workStateAction.isPending}
        />
      )}

      {tab === "noise" && (
        <NoiseKeywordSplitView
          candidates={noiseCandidates}
          lineStates={lineStates}
          onLineState={setLineState}
        />
      )}
      {tab === "source" && (
        <SourceSettingView
          selectedReceipt={selectedReceipt}
          linkOptions={linkOptions}
          pending={workStateAction.isPending || linkOptionsQ.isLoading}
          onWorkStateAction={(payload, options) => workStateAction.mutate(payload, options)}
          sourceLinks={sourceLinks}
          onSourceLinksChange={onSourceLinksChange}
        />
      )}
      {tab === "done" && <SplitCompletedView rows={completedRows} />}
      {tab === "settings" && <SplitSettingsView rows={splitRuleRows} />}
    </>
  );
}

function ReceiptWorkbench({
  queueFilter,
  queueStats,
  receipts,
  selectedReceipt,
  selectedLine,
  lineStates,
  onQueueFilter,
  onSelectReceipt,
  onSelectLine,
  onLineState,
  onReceiptAction,
  busy,
}) {
  const effectiveLine =
    selectedLine?.kind === "noise"
      ? selectedReceipt?.lines.find((line) => line.kind !== "section" && line.kind !== "noise") || selectedLine
      : selectedLine;
  if (!selectedReceipt) {
    return <EmptyState icon={Icon.Receipt} title="검수할 영수증이 없습니다" sub="수집워커가 만든 가공상태가 생기면 여기에 표시됩니다." />;
  }
  return (
    <>
      <ReceiptReviewFlow />
      <div style={{ display: "grid", gridTemplateColumns: "300px minmax(0, 1fr) 340px", gap: 12, alignItems: "start" }}>
        <ReceiptQueuePanel
          activeFilter={queueFilter}
          stats={queueStats}
          receipts={receipts}
          selectedReceipt={selectedReceipt}
          onFilter={onQueueFilter}
          onSelectReceipt={onSelectReceipt}
        />
        <ReceiptLineViewer
          receipt={selectedReceipt}
          selectedLine={effectiveLine}
          lineStates={lineStates}
          onSelectLine={onSelectLine}
        />
        <ReceiptValidationPanel
          receipt={selectedReceipt}
          line={effectiveLine}
          state={lineStates[effectiveLine?.id] || effectiveLine?.state}
          onLineState={onLineState}
          onReceiptAction={onReceiptAction}
          busy={busy}
        />
      </div>
    </>
  );
}

function ReceiptQueuePanel({ activeFilter, stats, receipts, selectedReceipt, onFilter, onSelectReceipt }) {
  return (
    <div className="dv-card" style={{ padding: 0, overflow: "hidden", position: "sticky", top: 80 }}>
      <div style={{ padding: "12px 14px", borderBottom: "1px solid var(--border-subtle)" }}>
        <div className="t-caption">영수증 큐</div>
        <div className="t-small" style={{ marginTop: 3 }}>처리할 영수증을 먼저 고릅니다.</div>
      </div>
      <div style={{ padding: 12, display: "flex", gap: 6, flexWrap: "wrap", borderBottom: "1px solid var(--border-subtle)" }}>
        {stats.map((filter) => (
          <button
            key={filter.id}
            className={"dv-chip" + (activeFilter === filter.id ? " is-active" : "")}
            onClick={() => onFilter(filter.id)}
          >
            {filter.label}
            <span className="dv-chip-count">{filter.count}</span>
          </button>
        ))}
      </div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        {receipts.map((receipt) => (
          <button
            key={receipt.id}
            type="button"
            onClick={() => onSelectReceipt(receipt)}
            style={{
              border: 0,
              borderBottom: "1px solid var(--border-subtle)",
              background: selectedReceipt?.id === receipt.id ? "var(--orange-50)" : "var(--white)",
              padding: "13px 14px",
              textAlign: "left",
              color: "var(--fg-1)",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", gap: 8, alignItems: "flex-start" }}>
              <span style={{ minWidth: 0 }}>
                <span style={{ display: "block", fontSize: 13, fontWeight: 800 }}>{receipt.title}</span>
                <span style={{ display: "block", marginTop: 4, fontSize: 11, color: "var(--fg-3)", fontFamily: "var(--font-mono)" }}>
                  {receipt.id} · {receipt.time}
                </span>
              </span>
              <Badge tone={receipt.tone}>{receipt.status}</Badge>
            </div>
            <div style={{ marginTop: 8, display: "flex", gap: 5, flexWrap: "wrap" }}>
              <Badge tone="neutral">메뉴 아님 {receipt.counts.noise}</Badge>
              <Badge tone="orange">메뉴 {receipt.counts.menu}</Badge>
              <Badge tone="warn">보류 {receipt.counts.hold}</Badge>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}

function ReceiptLineViewer({ receipt, selectedLine, lineStates, onSelectLine }) {
  if (!receipt) return null;
  const visibleLines = receipt.lines.filter((line) => line.kind === "section" || line.kind !== "noise");
  return (
    <div className="dv-card" style={{ padding: 0, overflow: "hidden" }}>
      <div style={{ padding: 16, borderBottom: "1px solid var(--border-subtle)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", gap: 12, alignItems: "flex-start" }}>
          <div style={{ minWidth: 0 }}>
            <div className="t-h3">{receipt.title}</div>
            <div className="t-small" style={{ marginTop: 4 }}>{receipt.business} · {receipt.channel} · {receipt.store}</div>
          </div>
          <Badge tone={receipt.tone}>{receipt.status}</Badge>
        </div>
        <div style={{ marginTop: 12, display: "grid", gridTemplateColumns: "repeat(3, minmax(0, 1fr))", gap: 8 }}>
          <ReceiptSourceSummary label="사업장 원본" value={receipt.business} />
          <ReceiptSourceSummary label="채널 후보" value={receipt.channel} />
          <ReceiptSourceSummary label="상점 후보" value={receipt.store} />
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        {visibleLines.map((line) => {
          const state = lineStates[line.id] || line.state;
          const selected = selectedLine?.id === line.id;
          if (line.kind === "section") {
            return (
              <div key={line.id} style={{ padding: "9px 14px", background: "var(--cream-50)", borderBottom: "1px solid var(--border-subtle)" }}>
                <span className="t-caption">{line.text}</span>
              </div>
            );
          }
          return (
            <button
              key={line.id}
              type="button"
              onClick={() => onSelectLine(line.id)}
              style={{
                border: 0,
                borderBottom: "1px solid var(--border-subtle)",
                background: selected ? "var(--orange-50)" : line.kind === "noise" ? "var(--cream-50)" : "var(--white)",
                padding: "11px 14px",
                textAlign: "left",
                display: "grid",
                gridTemplateColumns: "54px minmax(0, 1fr) auto",
                gap: 10,
                alignItems: "center",
                color: "var(--fg-1)",
              }}
            >
              <span style={{ fontSize: 11, color: "var(--fg-4)", fontFamily: "var(--font-mono)" }}>{line.loc}</span>
              <span style={{ minWidth: 0 }}>
                <span style={{ display: "block", fontSize: 13, fontWeight: 700, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{line.text}</span>
                <span style={{ display: "block", marginTop: 3, fontSize: 11, color: "var(--fg-3)" }}>{line.reason}</span>
              </span>
              <span style={{ display: "flex", gap: 5, alignItems: "center" }}>
                <Badge tone={splitTypeTone(line.type)}>{line.type}</Badge>
                <Badge tone={state === "보류" ? "warn" : state === "확정" ? "success" : "neutral"}>{state}</Badge>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

function SourceSettingView({
  selectedReceipt,
  linkOptions,
  pending,
  onWorkStateAction,
  sourceLinks,
  onSourceLinksChange,
}) {
  const raw = selectedReceipt?.raw || {};
  const [selectedLocationId, setSelectedLocationId] = React.useState(raw.linkedLocationId || "");
  const [selectedPlatformId, setSelectedPlatformId] = React.useState(raw.linkedPlatformId || "");
  const [selectedStoreId, setSelectedStoreId] = React.useState(raw.linkedStoreId || "");

  React.useEffect(() => {
    setSelectedLocationId(raw.linkedLocationId || "");
    setSelectedPlatformId(raw.linkedPlatformId || "");
    setSelectedStoreId(raw.linkedStoreId || "");
    if (selectedReceipt) {
      onSourceLinksChange(buildSourceLinks(selectedReceipt, linkOptions, {
        locationId: raw.linkedLocationId,
        platformId: raw.linkedPlatformId,
        storeId: raw.linkedStoreId,
      }));
    }
  }, [selectedReceipt?.id, raw.linkedLocationId, raw.linkedPlatformId, raw.linkedStoreId, linkOptions.locations.length, linkOptions.platforms.length, linkOptions.stores.length]);

  if (!selectedReceipt) {
    return <EmptyState icon={Icon.Store} title="연결할 영수증이 없습니다" sub="검수 작업대에서 영수증을 먼저 선택하세요." />;
  }

  const availableStores = linkOptions.stores.filter((store) => (
    (!selectedLocationId || store.locationId === selectedLocationId) &&
    (!selectedPlatformId || store.platformId === selectedPlatformId)
  ));
  const rows = [
    {
      id: "business",
      label: "사업장",
      source: sourceLabel(selectedReceipt.business, "사업장 후보 없음"),
      evidence: "receipt_work_states.sourceBusinessLabel",
      value: selectedLocationId,
      options: linkOptions.locations.map((item) => ({ id: item.id, name: item.name })),
      onChange: (value) => {
        setSelectedLocationId(value);
        const store = linkOptions.stores.find((item) => item.id === selectedStoreId);
        if (store && store.locationId !== value) setSelectedStoreId("");
      },
    },
    {
      id: "channel",
      label: "판매채널",
      source: sourceLabel(selectedReceipt.channel, "판매채널 후보 없음"),
      evidence: "receipt_work_states.sourceSalesChannelLabel",
      value: selectedPlatformId,
      options: linkOptions.platforms.map((item) => ({ id: item.id, name: item.name })),
      onChange: (value) => {
        setSelectedPlatformId(value);
        const store = linkOptions.stores.find((item) => item.id === selectedStoreId);
        if (store && store.platformId !== value) setSelectedStoreId("");
      },
    },
    {
      id: "store",
      label: "상점",
      source: sourceLabel(selectedReceipt.store, "상점 후보 없음"),
      evidence: "receipt_work_states.sourceStoreLabel",
      value: selectedStoreId,
      options: availableStores.map((item) => ({ id: item.id, name: item.name })),
      onChange: (value) => {
        setSelectedStoreId(value);
        const store = linkOptions.stores.find((item) => item.id === value);
        if (store) {
          setSelectedLocationId(store.locationId || "");
          setSelectedPlatformId(store.platformId || "");
        }
      },
    },
  ];

  const applyLink = () => {
    if (!selectedLocationId && !selectedPlatformId && !selectedStoreId) return;
    onWorkStateAction(
      {
        receiptId: raw.receiptInboxId || selectedReceipt.id,
        body: {
          action: "link",
          linkedLocationId: selectedLocationId || null,
          linkedPlatformId: selectedPlatformId || null,
          linkedStoreId: selectedStoreId || null,
        },
      },
      {
        onSuccess: (response) => {
          const item = response?.item || {};
          onSourceLinksChange(buildSourceLinks(selectedReceipt, linkOptions, {
            locationId: item.linkedLocationId || selectedLocationId,
            platformId: item.linkedPlatformId || selectedPlatformId,
            storeId: item.linkedStoreId || selectedStoreId,
          }));
        },
      },
    );
  };

  const unlink = () => {
    onWorkStateAction(
      {
        receiptId: raw.receiptInboxId || selectedReceipt.id,
        body: { action: "unlink" },
      },
      {
        onSuccess: () => {
          setSelectedLocationId("");
          setSelectedPlatformId("");
          setSelectedStoreId("");
          onSourceLinksChange(buildSourceLinks(selectedReceipt, linkOptions, {}));
        },
      },
    );
  };

  return (
    <div style={{ display: "grid", gridTemplateColumns: "minmax(0, 1fr) 320px", gap: 12, alignItems: "start" }}>
      <div className="dv-card" style={{ padding: 0, overflow: "hidden" }}>
        <div style={{ padding: 16, borderBottom: "1px solid var(--border-subtle)" }}>
          <div className="t-h3">사업장 설정</div>
          <div className="t-small" style={{ marginTop: 4 }}>
            원본에서 올라온 사업장·판매채널·상점 값을 우리 연결 트리에 붙입니다.
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column" }}>
          {rows.map((row) => {
            const link = sourceLinks[row.id] || { source: row.source, target: "", status: "unlinked" };
            const linked = Boolean(row.value);
            return (
              <div key={row.id} style={{ padding: 16, borderBottom: "1px solid var(--border-subtle)" }}>
                <div style={{ display: "grid", gridTemplateColumns: "150px minmax(0, 1fr) 260px", gap: 12, alignItems: "center" }}>
                  <div>
                    <div className="t-caption">{row.label}</div>
                    <div style={{ marginTop: 4, fontSize: 14, fontWeight: 800, color: "var(--fg-1)" }}>{link.source || row.source}</div>
                    <div style={{ marginTop: 3, fontSize: 11, color: "var(--fg-3)" }}>{row.evidence}</div>
                  </div>

                  <label style={{ display: "flex", flexDirection: "column", gap: 5, minWidth: 0 }}>
                    <span style={{ fontSize: 11, color: "var(--fg-3)", fontWeight: 700 }}>우리 {row.label} 선택</span>
                    <select
                      value={row.value || ""}
                      onChange={(event) => row.onChange(event.target.value)}
                      style={{
                        height: 36,
                        border: "1px solid var(--border-default)",
                        borderRadius: "var(--r-sm)",
                        padding: "0 10px",
                        background: "var(--white)",
                        color: "var(--fg-1)",
                        fontSize: 13,
                        fontWeight: 700,
                      }}
                    >
                      <option value="">선택 필요</option>
                      {row.options.map((option) => (
                        <option key={option.id} value={option.id}>{option.name}</option>
                      ))}
                    </select>
                  </label>

                  <div style={{ display: "flex", gap: 6, flexWrap: "wrap", justifyContent: "flex-end" }}>
                    <Badge tone={linked ? "success" : "warn"}>{linked ? "연결됨" : "미연결"}</Badge>
                    <Button
                      variant="primary"
                      size="xs"
                      icon={Icon.Check}
                      disabled={pending || (!selectedLocationId && !selectedPlatformId && !selectedStoreId)}
                      onClick={applyLink}
                    >
                      {linked ? "변경 적용" : "연동"}
                    </Button>
                    {linked && (
                      <Button variant="ghost" size="xs" icon={Icon.Refresh} disabled={pending} onClick={unlink}>연결 해지</Button>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="dv-card" style={{ padding: 16, position: "sticky", top: 80 }}>
        <div className="t-caption">연결 트리 반영</div>
        <div className="t-small" style={{ marginTop: 4, marginBottom: 12 }}>
          연동한 값은 왼쪽 연결 트리에 바로 반영됩니다.
        </div>
        <SourceLinkedPreview sourceLinks={sourceLinks} />
      </div>
    </div>
  );
}

function SourceLinkedTree({ sourceLinks, linkedTree, selectedStore, setPage, setSelectedStore }) {
  if (Array.isArray(linkedTree) && linkedTree.length > 0) {
    return (
      <div style={{ marginBottom: 10 }}>
        {linkedTree.map((business) => (
          <CollectTreeNode
            key={business.id}
            level={1}
            step="1"
            name={`${business.name} · ${business.count}`}
            status="ok"
            defaultOpen
          >
            {business.platforms.map((channel) => (
              <CollectTreeNode
                key={channel.id}
                level={2}
                step="2"
                name={`${channel.name} · ${channel.count}`}
                status={channel.platformId ? "ok" : "warn"}
                defaultOpen
              >
                {channel.stores.map((store) => (
                  <CollectTreeNode
                    key={store.id}
                    level={3}
                    step="3"
                    name={`${store.name} · ${store.count}`}
                    status={store.status}
                    selected={selectedStore === `linked:${store.storeId || store.id}`}
                    onSelect={() => {
                      setPage("classify");
                      setSelectedStore(`linked:${store.storeId || store.id}`);
                    }}
                    leaf
                  />
                ))}
              </CollectTreeNode>
            ))}
          </CollectTreeNode>
        ))}
        <div style={{ height: 1, background: "var(--border-subtle)", margin: "10px 4px" }}></div>
      </div>
    );
  }

  const business = sourceLinks.business || {};
  const channel = sourceLinks.channel || {};
  const store = sourceLinks.store || {};
  const businessLinked = business.status === "linked";
  const channelLinked = channel.status === "linked";
  const storeLinked = store.status === "linked";

  if (!businessLinked) {
    return (
      <div style={{ margin: "0 4px 10px", padding: 10, borderRadius: "var(--r-sm)", background: "var(--cream-50)", color: "var(--fg-3)", fontSize: 12 }}>
        영수증 통합분리에서 사업장·판매채널·상점을 먼저 연결하세요.
      </div>
    );
  }

  return (
    <div style={{ marginBottom: 10 }}>
      <CollectTreeNode level={1} step="1" name={business.target} status="ok" defaultOpen>
        {channelLinked ? (
          <CollectTreeNode level={2} step="2" name={channel.target} status="ok" defaultOpen>
            {storeLinked ? (
              <CollectTreeNode
                level={3}
                step="3"
                name={store.target}
                status="ok"
                selected={selectedStore === "source-linked"}
                onSelect={() => { setPage("receipts"); setSelectedStore("source-linked"); }}
                leaf
              />
            ) : (
              <CollectTreeAddRow level={3} label="상점 연결 필요" />
            )}
          </CollectTreeNode>
        ) : (
          <CollectTreeAddRow level={2} label="판매채널 연결 필요" />
        )}
      </CollectTreeNode>
      <div style={{ height: 1, background: "var(--border-subtle)", margin: "10px 4px" }}></div>
    </div>
  );
}

function SourceLinkedPreview({ sourceLinks }) {
  const rows = [
    ["사업장", sourceLinks.business],
    ["판매채널", sourceLinks.channel],
    ["상점", sourceLinks.store],
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {rows.map(([label, link]) => (
        <div key={label} style={{ border: "1px solid var(--border-subtle)", borderRadius: "var(--r-sm)", padding: 10, background: "var(--cream-50)" }}>
          <div style={{ display: "flex", justifyContent: "space-between", gap: 8, alignItems: "center" }}>
            <span className="t-caption">{label}</span>
            <Badge tone={link?.status === "linked" ? "success" : "warn"}>{link?.status === "linked" ? "반영" : "대기"}</Badge>
          </div>
          <div style={{ marginTop: 5, fontSize: 13, fontWeight: 800, color: "var(--fg-1)" }}>{link?.target || "선택 필요"}</div>
          <div style={{ marginTop: 3, fontSize: 11, color: "var(--fg-3)" }}>원본: {link?.source || "-"}</div>
        </div>
      ))}
    </div>
  );
}

function NoiseKeywordSplitView({ candidates, lineStates, onLineState }) {
  const [selectedNoiseId, setSelectedNoiseId] = React.useState(candidates[0]?.id || "");
  const selected = candidates.find((candidate) => candidate.id === selectedNoiseId) || candidates[0];

  if (!selected) {
    return <EmptyState icon={Icon.Check} title="메뉴 아님 후보가 없습니다" sub="수집된 키워드에서 제외할 항목이 생기면 여기에 표시됩니다." />;
  }

  const state = lineStates[selected.id] || selected.state;

  return (
    <div style={{ display: "grid", gridTemplateColumns: "320px minmax(0, 1fr) 340px", gap: 12, alignItems: "start" }}>
      <div className="dv-card" style={{ padding: 0, overflow: "hidden", position: "sticky", top: 80 }}>
        <div style={{ padding: "12px 14px", borderBottom: "1px solid var(--border-subtle)" }}>
          <div className="t-caption">메뉴 아님 후보</div>
          <div className="t-small" style={{ marginTop: 3 }}>배달팁, 할인, 합계처럼 메뉴/차감에 쓰지 않을 줄만 먼저 봅니다.</div>
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          {candidates.map((candidate) => {
            const candidateState = lineStates[candidate.id] || candidate.state;
            return (
              <button
                key={candidate.id}
                type="button"
                onClick={() => setSelectedNoiseId(candidate.id)}
                style={{
                  border: 0,
                  borderBottom: "1px solid var(--border-subtle)",
                  background: selected.id === candidate.id ? "var(--orange-50)" : "var(--white)",
                  padding: "12px 14px",
                  textAlign: "left",
                  color: "var(--fg-1)",
                }}
              >
                <div style={{ display: "flex", justifyContent: "space-between", gap: 8, alignItems: "flex-start" }}>
                  <span style={{ minWidth: 0 }}>
                    <span style={{ display: "block", fontSize: 13, fontWeight: 800 }}>{candidate.text}</span>
                    <span style={{ display: "block", marginTop: 3, fontSize: 11, color: "var(--fg-3)" }}>
                      {candidate.receipt.business} · {candidate.receipt.channel}
                    </span>
                  </span>
                  <Badge tone={candidateState === "확정" ? "success" : candidateState === "보류" ? "warn" : "neutral"}>{candidateState}</Badge>
                </div>
              </button>
            );
          })}
        </div>
      </div>

      <div className="dv-card" style={{ padding: 0, overflow: "hidden" }}>
        <div style={{ padding: 16, borderBottom: "1px solid var(--border-subtle)" }}>
          <div className="t-h3">{selected.receipt.title}</div>
          <div className="t-small" style={{ marginTop: 4 }}>
            이 탭에서 제외한 줄은 원본에는 남고, 연결 트리·메뉴 매핑·차감으로 넘어가지 않습니다.
          </div>
        </div>
        <div style={{ padding: 16, display: "grid", gridTemplateColumns: "repeat(3, minmax(0, 1fr))", gap: 8, borderBottom: "1px solid var(--border-subtle)" }}>
          <ReceiptSourceSummary label="영수증" value={selected.receipt.id} />
          <ReceiptSourceSummary label="위치" value={selected.loc} />
          <ReceiptSourceSummary label="후보" value={selected.text} />
        </div>
        <div style={{ padding: 16 }}>
          <div className="t-caption" style={{ marginBottom: 8 }}>왜 메뉴가 아닐 수 있나요?</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3, minmax(0, 1fr))", gap: 8 }}>
            <ReceiptSourceSummary label="워커 근거" value={selected.reason} />
            <ReceiptSourceSummary label="처리 효과" value="메뉴/차감 제외" />
            <ReceiptSourceSummary label="원본 보존" value="영수증 원문은 유지" />
          </div>
        </div>
      </div>

      <div className="dv-card" style={{ padding: 16, position: "sticky", top: 80 }}>
        <div className="t-caption">선택 후보</div>
        <div style={{ marginTop: 6, fontSize: 20, lineHeight: 1.2, fontWeight: 800 }}>{selected.text}</div>
        <div style={{ marginTop: 10, padding: 10, borderRadius: "var(--r-sm)", background: "var(--cream-50)", border: "1px solid var(--border-subtle)", fontSize: 12, color: "var(--fg-2)", lineHeight: 1.5 }}>
          여기서는 메뉴가 아닌 줄을 `차감 제외`로 따로 빼는 작업만 합니다.
        </div>
        <div style={{ marginTop: 16, display: "grid", gridTemplateColumns: "1fr", gap: 8 }}>
          <Button variant="primary" size="sm" icon={Icon.Check} onClick={() => onLineState(selected.id, "확정")}>메뉴 아님으로 제외</Button>
          <Button variant="ghost" size="sm" icon={Icon.Moon} onClick={() => onLineState(selected.id, "보류")}>나중에 확인</Button>
          <Button variant="ghost" size="sm" icon={Icon.Refresh} onClick={() => onLineState(selected.id, "키워드 수집")}>키워드 수집으로 돌림</Button>
          <Button variant="ghost" size="sm" icon={Icon.X} onClick={() => onLineState(selected.id, "검수 필요")}>되돌리기</Button>
        </div>
      </div>
    </div>
  );
}

function ReceiptValidationPanel({ receipt, line, state, onLineState, onReceiptAction, busy }) {
  if (!receipt || !line) return null;
  const isNoise = line.type === "노이즈";
  const linkedStore = Boolean(receipt.raw?.linkedStoreId);
  return (
    <div className="dv-card" style={{ padding: 16, position: "sticky", top: 80 }}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 10, alignItems: "flex-start" }}>
        <div style={{ minWidth: 0 }}>
          <div className="t-caption">선택 라인</div>
          <div style={{ marginTop: 6, fontSize: 18, lineHeight: 1.25, fontWeight: 800 }}>{line.text}</div>
        </div>
        <Badge tone={splitTypeTone(line.type)}>{line.type}</Badge>
      </div>

      <div style={{ marginTop: 14, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
        <ReceiptSourceSummary label="영수증" value={receipt.id} />
        <ReceiptSourceSummary label="위치" value={line.loc} />
      </div>
      <div style={{ marginTop: 8, display: "grid", gridTemplateColumns: "1fr", gap: 8 }}>
        <ReceiptSourceSummary label="워커 제안 근거" value={line.reason} />
        <ReceiptSourceSummary label="현재 상태" value={state || "검수 필요"} />
        <ReceiptSourceSummary label="다음 위치" value={line.next} />
      </div>

      {isNoise && (
        <div style={{ marginTop: 14, padding: 10, borderRadius: "var(--r-sm)", background: "var(--cream-50)", border: "1px solid var(--border-subtle)" }}>
          <div className="t-caption" style={{ marginBottom: 6 }}>노이즈 적용 미리보기</div>
          <div style={{ fontSize: 12, color: "var(--fg-2)", lineHeight: 1.5 }}>
            이 줄은 메뉴 후보와 연결 트리로 넘어가지 않고, 원본 영수증에는 그대로 남습니다.
          </div>
        </div>
      )}

      <div style={{ marginTop: 16 }}>
        <div className="t-caption" style={{ marginBottom: 8 }}>사용자 검증</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
          <Button variant="primary" size="sm" icon={Icon.Check} onClick={() => onLineState(line.id, "확정")}>{isNoise ? "노이즈 확정" : "확정"}</Button>
          <Button variant="ghost" size="sm" icon={Icon.Moon} onClick={() => onLineState(line.id, "보류")}>보류</Button>
          <Button variant="ghost" size="sm" icon={Icon.X} onClick={() => onLineState(line.id, "노이즈")}>노이즈</Button>
          <Button variant="ghost" size="sm" icon={Icon.Refresh} onClick={() => onLineState(line.id, "검수 필요")}>되돌리기</Button>
        </div>
      </div>

      <div style={{ marginTop: 16, paddingTop: 14, borderTop: "1px solid var(--border-subtle)" }}>
        <div className="t-caption" style={{ marginBottom: 8 }}>영수증 처리</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 8 }}>
          <Button
            variant="primary"
            size="sm"
            icon={Icon.Check}
            disabled={busy || !linkedStore}
            onClick={() => onReceiptAction(receipt, "complete")}
          >
            영수증 완료
          </Button>
          <Button
            variant="ghost"
            size="sm"
            icon={Icon.Moon}
            disabled={busy}
            onClick={() => onReceiptAction(receipt, "hold")}
          >
            영수증 보류
          </Button>
          <Button
            variant="ghost"
            size="sm"
            icon={Icon.X}
            disabled={busy}
            onClick={() => onReceiptAction(receipt, "ignore")}
          >
            영수증 무시
          </Button>
        </div>
      </div>
    </div>
  );
}

function ReceiptAnalysisSummary({ receipts }) {
  const stats = React.useMemo(() => {
    const rows = Array.isArray(receipts) ? receipts : [];
    const sourceCount = rows.reduce((total, receipt) => (
      total + receipt.lines.filter((line) => ["사업장", "판매채널", "상점"].includes(line.type)).length
    ), 0);
    const menuCount = rows.reduce((total, receipt) => (
      total + receipt.lines.filter((line) => line.kind === "menu").length
    ), 0);
    const noiseCount = rows.reduce((total, receipt) => total + receipt.counts.noise, 0);
    const heldCount = rows.filter((receipt) => receipt.raw?.reviewStatus === "held").length;
    return [
      { label: "가공상태", value: rows.length, tone: rows.length > 0 ? "success" : "neutral", note: "receipt_work_states" },
      { label: "원본/source", value: sourceCount, tone: sourceCount > 0 ? "success" : "neutral", note: "사업장·판매채널·상점 후보" },
      { label: "메뉴 후보", value: menuCount, tone: menuCount > 0 ? "orange" : "neutral", note: "노이즈 제외 후 입력 줄" },
      { label: "메뉴 아님", value: noiseCount, tone: noiseCount > 0 ? "warn" : "neutral", note: heldCount > 0 ? `보류 ${heldCount}건 포함` : "차감 제외 후보" },
    ];
  }, [receipts]);
  return (
    <div className="dv-card" style={{ padding: "12px 14px", marginBottom: 12 }}>
      <div style={{ display: "grid", gridTemplateColumns: "180px repeat(4, minmax(0, 1fr))", gap: 10, alignItems: "center" }}>
        <div>
          <div className="t-caption">현재 가공상태</div>
          <div className="t-small" style={{ marginTop: 3 }}>수집워커가 만든 후보 기준</div>
        </div>
        {stats.map((fact) => (
          <div key={fact.label} style={{ minWidth: 0, border: "1px solid var(--border-subtle)", borderRadius: "var(--r-sm)", padding: "9px 10px", background: "var(--cream-50)" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
              <span style={{ fontSize: 11, color: "var(--fg-3)", fontWeight: 700, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{fact.label}</span>
              <Badge tone={fact.tone}>{fact.value}</Badge>
            </div>
            <div style={{ marginTop: 5, fontSize: 11, color: "var(--fg-3)", lineHeight: 1.35 }}>{fact.note}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function ReceiptReviewFlow() {
  return (
    <div style={{
      display: "grid",
      gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
      gap: 8,
      marginBottom: 12,
    }}>
      {RECEIPT_REVIEW_STEPS.map((step, index) => (
        <div key={step.title} style={{
          border: "1px solid var(--border-subtle)",
          borderRadius: "var(--r-sm)",
          padding: 11,
          background: "var(--white)",
          minWidth: 0,
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 5 }}>
            <span style={{
              width: 18,
              height: 18,
              borderRadius: 5,
              background: index === 1 ? "var(--orange-100)" : "var(--green-100)",
              color: index === 1 ? "var(--orange-700)" : "var(--green-700)",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 10,
              fontWeight: 800,
              flexShrink: 0,
            }}>{index + 1}</span>
            <span style={{ fontSize: 12, fontWeight: 800, color: "var(--fg-1)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{step.title}</span>
          </div>
          <div style={{ fontSize: 11, color: "var(--fg-3)", lineHeight: 1.4 }}>{step.body}</div>
        </div>
      ))}
    </div>
  );
}

function SplitCompletedView({ rows }) {
  return (
    <div className="dv-card" style={{ padding: 0, overflow: "hidden" }}>
      <div style={{ padding: 16, borderBottom: "1px solid var(--border-subtle)" }}>
        <div className="t-h3">분리 완료</div>
        <div className="t-small" style={{ marginTop: 4 }}>확정된 분리 결과와 다음 처리 위치를 확인합니다.</div>
      </div>
      {rows.length === 0 ? (
        <EmptyState icon={Icon.Check} title="분리 완료 항목이 없습니다" sub="사용자 확정 결과가 생기면 여기에 표시됩니다." />
      ) : (
      <table className="dv-table">
        <thead>
          <tr><th>확정값</th><th>타입</th><th>적용 범위</th><th>다음 상태</th><th>작업</th></tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.id}>
              <td style={{ fontWeight: 800 }}>{row.value}</td>
              <td><Badge tone={splitTypeTone(row.type)}>{splitTypeLabel(row.type)}</Badge></td>
              <td style={{ color: "var(--fg-3)", fontSize: 12 }}>{row.scope}</td>
              <td><Badge tone={row.next.includes("완료") ? "success" : "warn"}>{row.next}</Badge></td>
              <td><Button variant="ghost" size="xs" icon={Icon.Edit}>수정</Button></td>
            </tr>
          ))}
        </tbody>
      </table>
      )}
    </div>
  );
}

function SplitSettingsView({ rows }) {
  return (
    <div className="dv-card" style={{ padding: 0, overflow: "hidden" }}>
      <div style={{ padding: 16, borderBottom: "1px solid var(--border-subtle)" }}>
        <div className="t-h3">분리 설정</div>
        <div className="t-small" style={{ marginTop: 4 }}>사용자가 확정한 분리 기준을 수정하거나 해제합니다. 저장 기준은 워커 제안에만 사용됩니다.</div>
      </div>
      {rows.length === 0 ? (
        <EmptyState icon={Icon.Settings} title="저장된 분리 기준이 없습니다" sub="확정된 메뉴 아님 기준이 생기면 여기에 표시됩니다." />
      ) : (
      <table className="dv-table">
        <thead>
          <tr><th>패턴/값</th><th>타입</th><th>워커 제안</th><th>최근 근거</th><th>작업</th></tr>
        </thead>
        <tbody>
          {rows.map((rule) => (
            <tr key={rule.id}>
              <td style={{ fontWeight: 800 }}>{rule.value}</td>
              <td><Badge tone={splitTypeTone(rule.type)}>{splitTypeLabel(rule.type)}</Badge></td>
              <td>{rule.auto ? <Badge tone="success">제안 사용</Badge> : <Badge tone="neutral">제안 중지</Badge>}</td>
              <td style={{ color: "var(--fg-3)", fontSize: 12 }}>{rule.lastEvidence}</td>
              <td>
                <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                  <Button variant="ghost" size="xs" icon={Icon.Edit}>수정</Button>
                  <Button variant="ghost" size="xs" icon={Icon.Refresh}>해제</Button>
                  <Button variant="danger" size="xs" icon={Icon.Trash}>삭제</Button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      )}
    </div>
  );
}

function splitTypeTone(type) {
  if (type === "사업장" || type === "판매채널" || type === "상점") return "success";
  if (type === "메뉴") return "orange";
  if (type === "보류") return "warn";
  return "neutral";
}

function splitTypeLabel(type) {
  return type === "노이즈" ? "메뉴 아님" : type;
}

const RECEIPT_QUEUE_FILTERS = [
  { id: "needs_review", label: "검수 필요" },
  { id: "menu_review", label: "메뉴 후보" },
  { id: "hold", label: "보류" },
  { id: "all", label: "전체" },
];

const RECEIPT_REVIEW_STEPS = [
  { title: "원본 고정값 확인", body: "branchName은 사업장 후보로 요약하고, 채널/상점은 원문 근거가 있을 때만 확정합니다." },
  { title: "메뉴 아님 먼저 분리", body: "금액·할인·배달팁·요청 줄은 메뉴 후보로 넘어가기 전에 메뉴 아님 탭에서 검증합니다." },
  { title: "메뉴 구간 검수", body: "메뉴 헤더 아래 줄을 메뉴/옵션/보류로 나누고, 원문 위치를 근거로 남깁니다." },
  { title: "보류 사유 남김", body: "채널·상점 미확인, 옵션 경계, 메뉴명 줄바꿈은 보류 사유로 연결 트리에 넘기지 않습니다." },
];

function ReceiptSourceSummary({ label, value }) {
  return (
    <div style={{ border: "1px solid var(--border-subtle)", borderRadius: "var(--r-sm)", padding: 10, background: "var(--cream-50)", minWidth: 0 }}>
      <div className="t-caption">{label}</div>
      <div style={{ marginTop: 4, fontSize: 13, fontWeight: 800, color: "var(--fg-1)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{value}</div>
    </div>
  );
}

// ─── 영수증 수신 헬스 스트립 ────────────────────
function ReceiptHealthStrip({ onOpenFeed }) {
  const countsQ = useCollectInboxCounts();
  const counts = countsQ.data || {};
  return (
    <div style={{
      display: "inline-flex", alignItems: "center", gap: 0,
      background: "var(--white)",
      border: "1px solid var(--border-subtle)",
      borderRadius: "var(--r-pill)",
      padding: 4,
      boxShadow: "var(--shadow-xs)"
    }}>
      <HealthChip label="원본 수신" value={counts.total ?? "-"} color="var(--green-500)" pulse={!countsQ.isError} />
      <button onClick={onOpenFeed} style={{
        marginLeft: 8,
        background: "var(--gray-900)",
        color: "var(--white)",
        border: 0,
        borderRadius: "var(--r-pill)",
        padding: "8px 16px",
        fontSize: 12, fontWeight: 600,
        cursor: "pointer",
        display: "inline-flex", alignItems: "center", gap: 6,
        fontFamily: "inherit"
      }}>
        <Icon.Activity size={13} />
        원본 수신 피드
      </button>
    </div>);

}

function HealthChip({ label, value, color, pulse }) {
  return (
    <div style={{ padding: "6px 14px", display: "flex", flexDirection: "column", lineHeight: 1.1, alignItems: "flex-start" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        {pulse && <span style={{
          width: 6, height: 6, borderRadius: "50%", background: color,
          boxShadow: `0 0 0 0 ${color}66`,
          animation: "dvvbPulse 1.6s ease-out infinite"
        }} />}
        <span style={{ fontSize: 10, color: "var(--fg-4)", fontWeight: 600 }}>{label}</span>
      </div>
      <span style={{ fontSize: 16, fontWeight: 800, color, marginTop: 2, fontFeatureSettings: "'tnum' 1, 'lnum' 1" }}>{value}</span>
    </div>);

}

function HealthSep() {
  return <span style={{ width: 1, height: 28, background: "var(--border-subtle)" }} />;
}

function CollectTreeNode({
  level,
  step,
  name,
  status = "ok",
  leaf,
  selected,
  onSelect,
  children,
  defaultOpen = false,
}) {
  const [open, setOpen] = React.useState(defaultOpen);
  const hasChildren = Boolean(children);
  const statusMeta = {
    ok: { label: "연결됨", color: "var(--green-500)", bg: "var(--green-100)" },
    warn: { label: "확인", color: "var(--amber-500)", bg: "#FFF8E1" },
    empty: { label: "대기", color: "var(--fg-4)", bg: "var(--cream-100)" },
  }[status] || { label: "대기", color: "var(--fg-4)", bg: "var(--cream-100)" };

  const handleClick = () => {
    if (leaf) {
      onSelect?.();
      return;
    }
    setOpen((value) => !value);
  };

  return (
    <div style={{ marginLeft: level === 1 ? 0 : 12 }}>
      <button
        type="button"
        onClick={handleClick}
        style={{
          width: "100%",
          minHeight: 34,
          display: "flex",
          alignItems: "center",
          gap: 7,
          padding: "7px 8px",
          marginBottom: 3,
          border: selected ? "1px solid var(--orange-300)" : "1px solid transparent",
          borderRadius: "var(--r-sm)",
          background: selected ? "var(--orange-50)" : "transparent",
          color: selected ? "var(--orange-700)" : "var(--fg-1)",
          cursor: "pointer",
          textAlign: "left",
        }}
      >
        <span style={{
          width: 18,
          height: 18,
          borderRadius: 5,
          background: statusMeta.bg,
          color: statusMeta.color,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 10,
          fontWeight: 800,
          flexShrink: 0,
        }}>
          {step}
        </span>
        <span style={{ flex: 1, minWidth: 0 }}>
          <span style={{
            display: "block",
            fontSize: 12,
            fontWeight: selected ? 800 : 700,
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}>
            {name}
          </span>
        </span>
        <span style={{
          fontSize: 9,
          fontWeight: 800,
          color: statusMeta.color,
          background: statusMeta.bg,
          borderRadius: 999,
          padding: "2px 6px",
          flexShrink: 0,
        }}>
          {statusMeta.label}
        </span>
        {hasChildren && (
          <span style={{
            color: "var(--fg-4)",
            transform: open ? "rotate(180deg)" : "none",
            transition: "transform 120ms ease",
            lineHeight: 0,
            flexShrink: 0,
          }}>
            <Icon.ChevronDown size={12} />
          </span>
        )}
      </button>
      {hasChildren && open && (
        <div style={{
          marginLeft: 9,
          paddingLeft: 9,
          borderLeft: "1px solid var(--border-subtle)",
        }}>
          {children}
        </div>
      )}
    </div>
  );
}

function CollectTreeAddRow({ level, label }) {
  return (
    <button
      type="button"
      style={{
        width: `calc(100% - ${level === 1 ? 0 : 12}px)`,
        minHeight: 30,
        marginLeft: level === 1 ? 0 : 12,
        marginBottom: 4,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px dashed var(--border-strong)",
        borderRadius: "var(--r-sm)",
        background: "var(--white)",
        color: "var(--fg-3)",
        fontSize: 12,
        fontWeight: 700,
        cursor: "pointer",
      }}
    >
      {label}
    </button>
  );
}

function CollectStoreHeader({ storeName, platform, business }) {
  return (
    <div className="dv-card" style={{ padding: 16 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
        <div style={{ minWidth: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 7, flexWrap: "wrap" }}>
            <Badge tone="success">연결됨</Badge>
            <span className="t-small" style={{ color: "var(--fg-3)" }}>
              {business} · {platform}
            </span>
          </div>
          <div style={{ fontSize: 20, lineHeight: 1.2, fontWeight: 800, color: "var(--fg-1)" }}>
            {storeName}
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
          <Button variant="ghost" size="sm" icon={Icon.Edit}>연결 수정</Button>
          <Button variant="ghost" size="sm" icon={Icon.Refresh}>동기화</Button>
        </div>
      </div>
    </div>
  );
}

// ─── 통합 메뉴 매핑 (확정 결과가 넘어온 뒤 별도 기능으로 연결) ───────────
function UnifiedMenuMapping() {
  return <EmptyState icon={Icon.Recipe} title="메뉴 매핑 대기 항목이 없습니다" sub="영수증 통합분리에서 메뉴 후보를 확정하면 이 슬롯으로 넘어옵니다." />;
}

export function SettingsCollectDesignRoute() {
  return (
    <div className="collect-design-scope" data-screen-label="설정 · 수집">
      <CollectDesignPanel />
    </div>
  );
}
